import { call, put, takeLatest } from "redux-saga/effects";
import GetAccountDataRequest from "Communication/ApiClasses/GetAccountDataRequest";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import { GET_ACCOUNT_DATA } from "Redux/Actions/actionTypes";

// worker
function* handleGetAccount(action) {
  yield put(doLoadingStart(`${GET_ACCOUNT_DATA}_SAGA`));
  const getAccountData = new GetAccountDataRequest(action.accountId);
  try {
    const result = yield call(getAccountData.getData);
    yield call(action.callback, result);
  } catch (error) {
    console.error("Error fetching account data:", error);
  } finally {
    yield put(doLoadingFinish(`${GET_ACCOUNT_DATA}_SAGA`));
  }
}

// watcher
export default function* getAccountWatcherSaga() {
  yield takeLatest(GET_ACCOUNT_DATA, handleGetAccount);
}
